import { configureStore } from "@reduxjs/toolkit";
import sessionReducer from "./slices/sessionSlice.mjs";

export default configureStore({
  reducer: {
    session: sessionReducer,
  },
});
